import app from "@/common/plugins/vueInstance";
import VFacebookLogin from "vue-facebook-login-component-next";

app.use(VFacebookLogin);
